import { GetLoan } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllLoans = (search = "") => {
    return dispatch => {
        dispatch({type:"LOANS_ACTION_START"})
        GetLoan(search).then((result)=>{
            dispatch({
                type: "LOANS_FETCH_DATA",
                payload: result.data.loans
            }) 
        }).catch((error)=>{
            dispatch({
                type: "LOANS_FETCH_DATA_FAILED",
                payload: error.response.data.error
            }) 
        });
    }
}
